/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import Switcher from '/client/src/components/switcher';

// TODO :32 :34 not connect

type PropsType = {
  skipEventLandingPage: boolean,
  showEventTimeAndDate: boolean,
  showTicketSalesTimeCountDown: boolean,
  showRemainingTicketCount: boolean,
  showPromotionTickets: boolean,
  showTickets: boolean,
  skipCollectAttendeeInformation: boolean,
  needCollectZipCode: boolean,
  needCollectPhoneNumber: boolean,
  isSetTicketsTotalCapacity: boolean,
  onHandleChangeCheckbox: ({}) => void
};

class EventDetailsAdvSet extends React.Component<PropsType> {
  props: PropsType;

  render(): React.Element<typeof React.Fragment> {
    const advSetSwichers = [
      {
        id: 'skip_event_landing_page',
        label: 'Hide event details',
        checked: this.props.skipEventLandingPage
      },
      {
        id: 'show_event_time_and_date',
        label: 'Hide event time and date',
        checked: !this.props.showEventTimeAndDate
      },
      {
        id: 'show_tickets',
        label: 'Disable ticket sales',
        checked: !this.props.showTickets
      },
      {
        id: 'show_promotion_tickets',
        label: 'Show post checkout event promotion',
        checked: this.props.showPromotionTickets
      },
      {
        id: 'show_ticket_sales_time_count_down',
        label: 'Hide remaining sales time for all ticket levels',
        checked: !this.props.showTicketSalesTimeCountDown
      },
      {
        id: 'show_remaining_ticket_count',
        label: 'Show remaining ticket quantity',
        checked: this.props.showRemainingTicketCount
      },
      {
        id: 'skip_collect_attendee_information',
        label: 'Send tickets to each ticket holders',
        checked: !this.props.skipCollectAttendeeInformation
      },
      {
        id: 'need_collect_zip_code',
        label: 'Do not collect postal codes',
        checked: !this.props.needCollectZipCode
      },
      {
        id: 'need_collect_phone_number',
        label: 'Do not collect phone numbers',
        checked: !this.props.needCollectPhoneNumber
      },
      {
        id: 'is_set_tickets_total_capacity',
        label: 'Limit total ticket sales',
        checked: this.props.isSetTicketsTotalCapacity
      }
    ];

     return (
       <>
         {_.map(advSetSwichers, (advI: {}, advK: number): React.Element<'div'> => {
           return (
             <div className="row" key={`advSetSwichers-${advK}`}>
               <div className="col-md-8 col-lg-6">
                 <Switcher
                   className='form-switcher-sm pull-left mb1rem'
                   id={advI.id}
                   name={advI.id}
                   index={advK}
                   checked={advI.checked}
                   onCallback={(e: any, status: boolean) => {
                     let _status = status;

                     if (
                       advI.id === 'show_event_time_and_date' ||
                       advI.id === 'show_ticket_sales_time_count_down' ||
                       advI.id === 'skip_collect_attendee_information' ||
                       advI.id === 'need_collect_zip_code' ||
                       advI.id === 'need_collect_phone_number' ||
                       advI.id === 'show_tickets'
                     ) {
                       _status = !status;
                     }

                     this.props.onHandleChangeCheckbox({
                       target: {
                         checked: _status,
                         name: advI.id
                       }
                     });
                   }}
                   label={advI.label}
                 />
               </div>
             </div>
           );
         })}
       </>
     );
  }
}

export default EventDetailsAdvSet;
